<template>
  <abby-media-container
    v-bind:sourceId="sourceId_SharedLibrary"
    v-bind:toolbarColor="toolbarColor"
    v-bind:toolbarColorDark="toolbarColorDark"
  />
</template>

<script>
import AbbyMediaContainer from '@/components/AbbyMediaContainer'
import { AbbyMediaSourceId, AppColor } from '@/config.js'

export default {
  name: "AbbySharedLibraryManager",
  components: {
    AbbyMediaContainer
  },
  data() {
    return {
      toolbarColor: AppColor.KioskTypeAbbyLight,
      toolbarColorDark: AppColor.KioskTypeAbbyDark,
      sourceId_SharedLibrary: AbbyMediaSourceId.SharedLibrary
    }
  }
}
</script>
